import Instrument from "shared/games/instruments/Instrument";
import { MixPuzzleInstrument } from "shared/games/mixpuzzles/types";

export default function getDefaultMixPuzzleInstrument(
  id: number,
  instrument: Instrument
): MixPuzzleInstrument {
  return {
    id,
    comp: null,
    instrument,
    volume: 0,
    eq_freq: "bass",
    eq_gain: 0,
    pan: "C",
  };
}
